import { type FunctionComponent } from "react";

import ownerIcon from "images/Common/ownerIcon.png";

import { type IBTIconProps } from "../BTIcon.types";

export const BTIconDeprecatedOwner: FunctionComponent<IBTIconProps> = ({
    size,
    style,
    className,
}) => {
    const sizeStyles = size ? { height: size, width: size } : {};
    return <img alt="" src={ownerIcon} style={{ ...sizeStyles, ...style }} className={className} />;
};
